import { useEffect, useRef } from 'react';
import { trackMixpanel } from '../utils/mixpanel';
import { useQuery } from 'react-ui';
import React from 'react';

export function QueryListener() {
  const { queries } = useQuery();
  const previousQueriesRef = useRef<typeof queries | null>(null);
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    // Skip tracking on initial load
    if (isInitialLoadRef.current) {
      isInitialLoadRef.current = false;
      previousQueriesRef.current = queries;
      return;
    }

    // Only track if queries have actually changed
    if (
      previousQueriesRef.current !== null &&
      JSON.stringify(previousQueriesRef.current) !== JSON.stringify(queries)
    ) {
      trackMixpanel('Queries', 'Changed', {
        queries: queries,
        previousQueries: previousQueriesRef.current,
      });
    }

    // Update previous queries for next comparison
    previousQueriesRef.current = queries;
  }, [queries]);

  return <></>;
}